import {
    createColumnInput,
} from "../../../components/table/c-table.logic";
import i18n from "../../../i18n";
import lodash from "lodash";
import { conditionFormChecker, putField } from "../../../utils/form";
import {
    createFieldInput,
    createFieldTextArea,
    createFieldTemplateBuilder,
} from "../../../components/input/template-builder/template-builder.logic";
import { defineAsyncComponent } from "vue";

const SurveyQuestionList = defineAsyncComponent(() => import("./survey-question/SurveyQuestionList"));

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.survey.title"),
            dataIndex: "title",
            customRender: ({ record }) => <div>{record.title}</div>,
            align: "center",
        }),
        createColumnInput({
            title: () => i18n.global.t("model.survey.description"),
            dataIndex: "description",
            customRender: ({ record }) => <div>{record.description}</div>,
            align: "center",
            search: { visible: () => false }
        }),
    ];
    return columns;
};

export const createFields = ({ props, data, key }) => {
    const { viewOnly, menuContext } = props;
    // const { useForm } = data;
    // const { modelRef } = useForm;
    // const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            ...createFieldHeaderSurvey({ props, data, key }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            visibleCardTitle: true,
                            dataProp: data,
                            itemsKey: `${prefix}surveyQuestions`,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "SurveyQuestionList" } })
                    );
                    return <SurveyQuestionList {...componentProp}></SurveyQuestionList>;
                }
            }
        ]
    });
};

export const createFieldHeaderSurvey = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                key: `${prefix}surveyHeader`,
                cardBorderProp: () =>  ({ title: "", headerSize: "small", class: "mt-3" }),
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ wrapperCol: { xs: 24, md: 24 } }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            key: `${prefix}title`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => `${i18n.global.t("model.survey.title")}`,
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model?.title,
                                        "onUpdate:value": (value) => (model.title = value),
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldTextArea({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            key: `${prefix}description`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => `${i18n.global.t("model.survey.description")}`,
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model?.description,
                                        "onUpdate:value": (value) => (model.description = value),
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                    ]})
                }),
            }),
        ]
    })
}